import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { IconButton } from "@material-ui/core"

export const Holder = styled(motion.div)`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 10000;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
`

export const Footer = styled.div`
  position: relative;
  width: 100%;
  height: 8em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #86a9a5;
`

export const Logo = styled.img`
  height: 70%;
`

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  flex: 1;
  padding: 4vw;
`
export const RightSection = styled.div`
  width: 40vw;
  background-image: ${({ img }) => `url(${img})`};
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
`

export const TitleHolder = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #513b69;
  font-family: NewParisKingSize-Regular;
  font-weight: 300;
  font-size: 6vw;
  line-height: 105%;
  color: #86a9a5;
`

export const TipHolder = styled.div`
  width: 80%;
  max-width: 700px;
  padding: 3vw 0;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 1em;
  color: #0b253c;
`

export const ContactHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1em;
`
export const ContactList = styled.ul`
  margin: 0;
  padding: 0;
`

export const ContactTitle = styled.li`
  font-style: normal;
  font-weight: bold;
  font-size: 1em;
  color: #0b253c;
  list-style: none;
  margin-bottom: 1.5em;
`
export const ContactValue = styled.li`
  font-style: normal;
  font-size: 1em;
  color: #0b253c;
  list-style: none;
  line-height: 150%;
`
export const AboutLink = styled(Link)`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
`
export const BackButton = styled(IconButton)`
  width: 3em;
  height: 3em;
`
export const BackIcon = styled.img`
  width: 100%;
`
